/**
 * Enumeration of all potential HTTP error codes
 */
export enum HTTPErrorCode {
  HTTP_ERROR_NO_NETWORK = -1,
  HTTP_ERROR_HOST_NOT_FOUND_1 = 0,
  HTTP_ERROR_HOST_NOT_FOUND_2 = 1,
  HTTP_ERROR_NOT_FOUND = 404,
  HTTP_ERROR_OUT_OF_SESSION = 401,
  HTTP_ERROR_FORBIDDEN = 403,
  HTTP_ERROR_SERVER_ERROR = 500,
  HTTP_ERROR_UNDER_MAINTENANCE_1 = 502,
  HTTP_ERROR_UNDER_MAINTENANCE_2 = 503,
  HTTP_ERROR_UNDER_MAINTENANCE_3 = 504
}
